import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function reportList(
  accountId: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${accountId}/report/list${queryString}`,
  );
}

export async function reportShow(accountId: string, report_id: string) {
  return await clientAxios.get(`account/${accountId}/report/${report_id}/show`);
}

export async function reportCreate(
  accountId: string,
  payload: {
    evaluation_id: string;
    name: string;
    description: string | null;
  },
) {
  return await clientAxios.post(`account/${accountId}/report/create`, payload);
}

export async function reportPatch(
  accountId: string,
  report_id: string,
  payload: { [key: string]: any },
) {
  return await clientAxios.patch(
    `account/${accountId}/report/${report_id}/patch`,
    { payload },
  );
}

export async function reportDelete(accountId: string, report_id: string) {
  return await clientAxios.del(
    `account/${accountId}/report/${report_id}/delete`,
  );
}
